<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <a-input v-model="queryParams.applicantName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请时间">
              <a-input v-model="queryParams.applyTime" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称">
              <global-select
                :value.sync="queryParams.planName"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本">
              <global-select
                :value.sync="queryParams.planVersion"
                selectType="selectSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                searchParam="planVersion"
                :allowClear="false"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="仅查询存在差异的物料" :labelCol="{ style: { width: '160px' } }">
              <a-switch :checked="queryParams.switchOne === 'Y'" @change="statusOnChange(queryParams)" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="显示">
              <global-select
                :value.sync="queryParams.lineTypeList"
                selectType="selectMultiple"
                :selectData="lineTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(queryParams)">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '100px' } }">
          <a-row class="align-center">
            <div class="plan-time pt5 pb5">计划运行概况</div>
            <a-col :md="7" :sm="24" class="ml20">
              <a-form-item label="主计划版本">
                <a-input v-model="planVersion" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间" :labelCol="{ style: { width: '120px' } }">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="table-page-operator-wrapper mt5 mb10">
          <!-- <a-button @click="handleDevelop">全部折叠</a-button>
          <a-button @click="handlePackUp">全部展开</a-button> -->
          <a-button @click="handleExport" v-hasPermi="['scp:scpMrpHorizontalSummary:reserveApprovalExport']">导出</a-button>
          <a-button @click="$refs.examineApproveModal.show()">审批</a-button>
        </div>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :expandedRowKeys="expandedRowKeys"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
        >
          <span slot="lineTypeNameTitle" class="align-center">项目&nbsp;
            <a-popover>
              <template slot="content">
                <p>针对需求总量不满足MOQ的情况，可在此选择按MOQ采购、按实际需求采购、或是不采购。</p>
              </template>
              <span><a-icon type="info-circle" /></span>
            </a-popover>
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="(record.boss || columnsAdd.includes(item.dataIndex)) && Number(text) < 0" :class="['color-red', {'line-ellipsis':item.ellipsis}]" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="record.boss || columnsOther.includes(item.dataIndex) && record.lineType === 'ASSIGN_QTY'" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex))" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
        <examine-approve-modal ref="examineApproveModal" :billNo="billNo" :processCoding="processCoding" @handle-success="handleOk3" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpHorizontalSummaryReservePlanApprovalList,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpHorizontalDatesDateDisplayList,
  apiScpMrpHorizontalSummaryReservePlanApprovalHead
} from '@/api/scp/reserve-goods-plan/reserve-plan-approval'
import ExamineApproveModal from './components/examine-approve-modal'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { generateLsTableResData } from '@/utils/util.js';
export default {
  // eslint-disable-next-line
  name: 'Reserve-plan-approval', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DressingByScreening,
    DressingByScreeningSetUp,
    ExamineApproveModal
  },
  data () {
    return {
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpHorizontalSummaryReservePlanApprovalList, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        applicantName: undefined,
        applyTime: undefined,
        planName: undefined,
        planVersion: undefined,
        switchOne: "N",
        lineTypeList: undefined,
        billNo: undefined
      },
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2800,
      tableList: [],
      // 表格字段
      columnsOrigin: [],
      columnsAdd: [],
      columnsOther: ['supplierCode', 'supplierName', 'prPoSummary', 'inTransit', 'qonhand', 'moqTypeName', 'moq'],
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          scopedSlots: { customRender: 'organizationName' },
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          align: 'center',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom' },
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          scopedSlots: { customRender: 'specification' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          scopedSlots: { customRender: 'name1' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          scopedSlots: { customRender: 'name2' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          scopedSlots: { customRender: 'name3' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '审批意见',
          dataIndex: 'approvalComments',
          scopedSlots: { customRender: 'approvalComments' },
          align: 'center'
        },
        {
          title: 'MPQ',
          dataIndex: 'fixedLotMultiplier',
          scopedSlots: { customRender: 'fixedLotMultiplier' },
          align: 'center'
        },

        {
          title: '备库L/T',
          dataIndex: 'safetyStockLeadTime',
          scopedSlots: { customRender: 'safetyStockLeadTime' },
          align: 'center'
        },
        {
          title: 'VMI库存',
          dataIndex: 'onhand',
          scopedSlots: { customRender: 'onhand' },
          align: 'center'
        },
        {
          title: '产业园期初',
          dataIndex: 'onhandVendorAssign',
          scopedSlots: { customRender: 'onhandVendorAssign' },
          align: 'center'
        },
        {
          title: '产业园盈余',
          dataIndex: 'invInTransitQty',
          scopedSlots: { customRender: 'invInTransitQty' },
          align: 'center'
        },
        {
          title: 'VMI在途',
          dataIndex: 'poInTransitQty',
          scopedSlots: { customRender: 'poInTransitQty' },
          align: 'center'
        },
        {
          title: '储备单',
          dataIndex: 'prPoQty',
          scopedSlots: { customRender: 'prPoQty' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          scopedSlots: { customRender: 'statusName' },
          align: 'center'
        },
        {
          title: '供应商编号',
          dataIndex: 'supplierCode',
          scopedSlots: { customRender: 'supplierCode' },
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          scopedSlots: { customRender: 'supplierName' },
          align: 'center'
        },
        {
          title: '供应商未发储备单',
          dataIndex: 'prPoSummary',
          width: 160,
          scopedSlots: { customRender: 'prPoSummary' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '供应商送货在途数',
          dataIndex: 'inTransit',
          scopedSlots: { customRender: 'inTransit' },
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '库存现有量',
          dataIndex: 'qonhand',
          scopedSlots: { customRender: 'qonhand' },
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: 'MOQ处理',
          dataIndex: 'moqTypeName',
          scopedSlots: { customRender: 'moqTypeName' },
          align: 'center'
        },
        {
          title: 'MOQ',
          dataIndex: 'moq',
          scopedSlots: { customRender: 'moq' },
          align: 'center'
        },
        {
          // title: '项目',
          dataIndex: 'lineTypeName',
          scopedSlots: { customRender: 'lineTypeName', title: "lineTypeNameTitle" },
          align: 'center'
        },
        {
          title: '总数量',
          dataIndex: 'summary',
          scopedSlots: { customRender: 'summary' },
          align: 'center'
        },
        {
          title: '期初',
          dataIndex: 'initial',
          scopedSlots: { customRender: 'initial' },
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName' },
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          scopedSlots: { customRender: 'planVersion' },
          align: 'center'
        }
      ],
      lineTypeListData: [], // 显示
      searchList1: [],
      searchList2: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      planVersion: "", // 主计划版本
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 计划运算完成时间
      expandedRowKeys: [], // table 展开
      billNo: "", // 单号
      processCoding: "" // 流程编码
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    if (Object.keys(this.$route.query).length > 0) {
      this.billNo = this.$route.query.bpmBillNo
      this.getSearchInfo(this.$route.query.bpmBillNo)
    }

    this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getLookupList('SCP_MRP_LINE_TYPE_PR', 'lineTypeListData')
    this.getCategoryIdList(true)
  },
  activated () {
    this.queryParams.applicantName = ""
    this.queryParams.applyTime = ""
    this.queryParams.planName = ""
    this.queryParams.planVersion = ""
    this.processCoding = ""
    this.$refs.dataTable.myDataSource = []
    if (Object.keys(this.$route.query).length > 0) {
      this.billNo = this.$route.query.bpmBillNo
      this.getSearchInfo(this.$route.query.bpmBillNo)
    }

    // this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getLookupList('SCP_MRP_LINE_TYPE_PR', 'lineTypeListData')
    this.getCategoryIdList(true)
  },
  mounted () {},
  methods: {
    // 表头查询信息填充
    getSearchInfo (billNo) {
      this.queryParams.billNo = billNo
      apiScpMrpHorizontalSummaryReservePlanApprovalHead(billNo).then(res => {
        if (res.data) {
          this.queryParams.applicantName = res.data.applicantName
          this.queryParams.applyTime = res.data.applyTime
          this.queryParams.planName = res.data.planName
          this.queryParams.planVersion = res.data.planVersion
          this.processCoding = res.data.processCoding
          this.onSearch()
        }
      })
    },
    recursiveExpand (arr, tmp) {
      for (let i = 0; i < arr.length; i++) {
        tmp.push(arr[i].id)
        if (arr[i].childList !== null && arr[i].childList !== undefined && arr[i].childList.length > 0) {
          this.recursiveExpand(arr[i].childList, tmp)
        }
      }
      return tmp
    },
    // 全部展开
    handleDevelop () {
      const tableList = JSON.parse(JSON.stringify(this.tableList))
      this.recursiveExpand(tableList, this.expandedRowKeys)
    },
    // 全部收起
    handlePackUp () {
      this.expandedRowKeys = [];
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    handleOk3 () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.getTableTime()
      this.$nextTick(() => {
        this.lineTypeListChange(this.queryParams.lineTypeList)
        this.$refs.dataTable.searchParams = this.queryParams;
        this.$refs.dataTable.getData();
      })
    },
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      const arr2 = tableList.map(item => item.id)
      const arr3 = Array.from(new Set(arr2))
      const arr4 = []
      for (let i = 0; i < tableList.length; i++) {
        for (let j = 0; j < arr3.length; j++) {
          if (tableList[i].id === arr3[j] && !arr4.includes(arr3[j])) {
            arr4.push(arr3[j])
            tableList[i].boss = true
          }
        }
      }
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.queryParams = JSON.parse(val.schemeDetailJson)
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        applicantName: undefined,
        applyTime: undefined,
        planName: undefined,
        planVersion: undefined,
        switchOne: "N",
        lineTypeList: undefined
      }
      this.tableList = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpHorizontalSummary/reservePlanApprovalExport', {
        ...this.queryParams
      }, `储备计划审批_${new Date().getTime()}.xlsx`)
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.queryParams = JSON.parse(element.schemeDetailJson)
              this.onSearch()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.queryParams).then(res => {
        if (res.data) {
          this.dataCollectStartDate = res.data.dataCollectStartDate && this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = res.data.planCompletionDate && this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      // 动态表头
      apiScpMrpHorizontalDatesDateDisplayList({ planVersion: this.queryParams.planVersion, dataType: "CALL" }).then(res => {
        if (res.data && res.data.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columnsOrigin))
          const arr = res.data
          const arr2 = ['lineTypeName', 'summary']
          arr.forEach((element, index) => {
            const obj = {
              title: element,
              dataIndex: `date${index + 1}`,
              scopedSlots: { customRender: `date${index + 1}` }
            }
            arr2.push(`date${index + 1}`)
            columns.splice(-3, 0, obj);
          });
          this.columnsAdd = arr2 || []
          this.columns = columns
          this.tableX = 2800 + res.data.length * 100
        } else {
          this.columns = JSON.parse(JSON.stringify(this.columnsOrigin))
        }
      })
    },
    // table的页码控制
    lineTypeListChange (val) {
      if (!val || val.length === 0) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 20
        return
      }
      if (val.length === 1 || val.length === 5) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["10", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 10
      }
      if (val.length === 2 || val.length === 4) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["8", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 8
      }
      if (val.length === 3) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["9", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 9
      }
    },
    statusOnChange (queryParams) {
      queryParams.switchOne = queryParams.switchOne === 'Y' ? 'N' : 'Y'
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_MRP_LINE_TYPE_PR") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute4 === "Y") {
              arr2.push(element.lookupCode)
            }
          });
          this.queryParams.lineTypeList = arr2
        }
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.plan-time{
  font-weight: bold;
}
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
.color-red {
  color: red
}
</style>
